import { FC, useCallback, ChangeEvent } from "react";
import { Typography } from "@mui/material";
import { NumberField } from "@/components/common/NumberField";

interface PlannedAmountItemProps {
  plannedAmount: number | string;
  index: number;
  label: string;
  fieldError?: string;
  onPlannedAmountChange: (value: number | undefined, index: number) => void;
}

export const PlannedAmountItem: FC<PlannedAmountItemProps> = ({
  plannedAmount,
  index,
  label,
  fieldError,
  onPlannedAmountChange,
}) => {
  const changeHandler = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = +event.target.value;

      onPlannedAmountChange(value !== 0 ? value : undefined, index);
    },
    [onPlannedAmountChange, index],
  );

  return (
    <NumberField
      fullWidth
      size="small"
      name={`planned_amounts[${index}]`}
      label={label}
      placeholder="0"
      variant="outlined"
      minValue={1}
      onChange={changeHandler}
      value={plannedAmount}
      error={!!fieldError}
      InputProps={{
        startAdornment: (
          <Typography pr={1} color="text.secondary">
            $
          </Typography>
        ),
      }}
    />
  );
};
